<template>
  <div class="authorization">
    <el-card class="box-card">
      <div v-if="isDelegation" class="logout-wrap">
        <el-button type="primary" @click="logoutDelegateAccount">{{ $t('Tool.BackToMyAccount') }}</el-button>
      </div>
      <div v-if="!isDelegation" class="admin-wrap">
        <div class="admin-wrap-form">
          <label>{{ $t('Tool.AuthOwned') }}</label>
          <label v-if="isAdmin">{{ $t('Tool.AdminUse') }}</label>
          <cargo-advance-select
            v-if="isAdmin"
            filterable
            :select-type="selectTypeNames.basic_data_User"
            callback-method-type="obj"
            :default-value="vb1.delegator || ''"
            :callback-params="{key:'delegator'}"
            @parentCallBack="setVb1Delegator"
          />
          <i v-if="isAdmin" class="go-btn" @click="goAdminDelegate">GO</i>
          <el-button class="flush-btn" :style="(!isAdmin ? 'margin-left: 10px;' : '') + 'width: unset;'" type="primary" @click="refreshVb1Grid">{{ $t('Tool.Refresh') }}</el-button>
        </div>
        <cargo-ag-grid
          :grid-options="vb1.gridOptions"
          :column-defs="vb1.columnDefs"
          :show-side-bar="false"
          :row-data="vb1.rowData"
        />

        <!-- 普通人-->
        <div v-if="!isAdmin" class="admin-wrap-form">
          <label style="width: 40px;">{{ $t('Tool.User') }}</label>
          <cargo-advance-select
            filterable
            :select-type="selectTypeNames.basic_data_User"
            callback-method-type="obj"
            :default-value="vb2.delegator || ''"
            @parentCallBack="p=>vb2.delegator=p.value"
          />
          <el-date-picker
            v-model="vb2.startTime"
            style="width:120px;margin-left: 10px;"
            type="date"
            :picker-options="{
              disabledDate: time => {
                return ( time.getTime() > new Date(vb2.endTime + ' 23:59:59').getTime() )
              }
            }"
            value-format="yyyy-MM-dd"
          />&nbsp;{{ $t('SeaExport.To') }}
          <el-date-picker
            v-model="vb2.endTime"
            style="width:120px;"
            type="date"
            :picker-options="{
              disabledDate: time => {
                return (
                  time.getTime() <
                  new Date(vb2.startTime + ' 00:00:00').getTime()
                )
              }
            }"
            value-format="yyyy-MM-dd"
          />
          <el-button class="flush-btn" type="primary" style="margin-left: 10px;" @click="onAddVb2">{{ $t('Tool.NewAuth') }}</el-button>
        </div>
        <cargo-ag-grid
          v-if="!isAdmin"
          :grid-options="vb2.gridOptions"
          :column-defs="vb2ColumnDefs"
          :show-side-bar="false"
          :row-data="vb2.rowData"
          @gridReady="params=>{vb2.gridApi=params.api}"
        />
        <div v-if="!isAdmin" class="admin-wrap-form">
          <label style="width: 100px;">{{ $t('Tool.AuthHistory') }}</label>
          <el-input v-model="vb3.filterStr" style="width: 150px;" @input="updateDelegationLog" />
          <el-button class="flush-btn" type="primary" style="margin-left: 10px;" @click="onShowAllLog">{{ $t('Tool.Refresh') }}</el-button>
        </div>
        <cargo-ag-grid
          v-if="!isAdmin"
          :grid-options="vb3.gridOptions"
          :column-defs="vb3ColumnDefs"
          :show-side-bar="false"
          :row-data="vb3.rowData"
          @gridReady="params=>{vb3.gridApi=params.api}"
        />
      </div>
    </el-card>

    <!-- 授权理由-->
    <el-dialog :visible="remarkView.visible" :title="$t('Tool.ConfirmAuth')" width="400px" custom-class="cargo-form-dialog" :close-on-click-modal="false" append-to-body @close="handleClose">
      <div>
        <span>{{ $t('Tool.InputAuthReason') + ':' }}</span>
        <span style="margin-top: 10px;">
          <el-input v-model="remarkView.remark" type="textarea" :rows="10" />
        </span>
      </div>
      <span slot="footer" style="padding:10px;">
        <el-button type="primary" @click="handleSubmit">{{ $t('SeaExport.Confirm') }}</el-button>
        <el-button @click="handleClose">{{ $t('SeaExport.Cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import go from '@/assets/go.gif'
import { getDelegationsByDelegateeId, delegate, logoutDelegate, searchSession, saveDelegate, getDelegationsByUserId, cancelDelegation } from '@/api/auth'
import { Assert } from '@/utils/validate'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { Base64 } from 'js-base64'
import { DocumentManage, stopBubble } from '@/utils/commonUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import StrUtils from '@/utils/StrUtils'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import moment from 'moment'
import DateUtils from '@/utils/dateUtils'

export default {
  name: 'DelegateInfoForm',
  components: { CargoAdvanceSelect },
  props: {
    isDelegation: { type: Boolean, default: false }
  },
  data() {
    return {
      go,
      selectTypeNames: TYPE_NAMES,
      documentManage: new DocumentManage(),
      vb1: {
        isAdmin: false,
        delegator: 0,
        gridOptions: {},
        columnDefs: null,
        rowData: []
      },
      vb2: {
        startTime: '',
        endTime: '',
        delegator: 0,
        gridOptions: {
          onRowClicked: this.onShowDelegation
        },
        gridApi: null,
        rowData: []
      },
      vb3: {
        gridOptions: {},
        filterStr: '',
        gridApi: null,
        oldData: [],
        rowData: []
      },
      remarkView: { // 授权理由
        visible: false,
        remark: ''
      },
      sourceData: [],
      date: '',
      value: ''
    }
  },
  computed: {
    ...mapGetters([
      'currentUserConfig',
      'userId',
      'currentDeptId',
      'language',
      'cachedViews',
      'isAdmin',
      'tenantId',
      'userInfo',
      'currentOfficeId'
    ]),
    vb2ColumnDefs() {
      return [
        { headerName: this.$t('Tool.UserName'), field: 'delegatee', width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('Tool.BeginDate'), field: 'startTime', width: 180,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          } },
        { headerName: this.$t('Tool.EndDate'), field: 'endTime', width: 180,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          } },
        { headerName: '', field: '', width: 80,
          sortable: false,
          cellRenderer: (params) => {
            const methodPath = this.documentManage.getPath('onCancelDelegation')
            return `<i class="x-link" onclick="${methodPath}('${params.data.uuid}')">X</i>`
          }
        }
      ]
    },
    vb3ColumnDefs() {
      return [
        { headerName: this.$t('Tool.UserName'), field: 'delegateId', width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('Tool.LoginTime'), field: 'loginDate', width: 180,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          } },
        { headerName: this.$t('Tool.ExitTime'), field: 'logoutDate', width: 180,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          } }
      ]
    },
    isZh() {
      return this.language === 'zh'
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('goGridUserDelegate', function(uid) {
      context.goGridUserDelegate(uid)
    })
    this.documentManage.set('onCancelDelegation', function(uuid) {
      context.onCancelDelegation(uuid)
    })
    this.vb1.columnDefs = [
      { headerName: this.$t('Tool.UserName'), field: 'delegator', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        }
      },
      { headerName: this.$t('Tool.BeginDate'), field: 'startTime', width: 200 },
      { headerName: this.$t('Tool.EndDate'), field: 'endTime', width: 200 },
      { headerName: '', field: '', width: 80,
        sortable: false,
        cellRenderer: (params) => {
          const methodPath = this.documentManage.getPath('goGridUserDelegate')
          return `<i class="go-link" onclick="${methodPath}(${params.data.delegator})">GO</i>`
        }
      }
    ]
    this.init()
  },
  methods: {
    init() {
      this.refreshVb1Grid()
      if (!this.isAdmin && !this.isDelegation) {
        // 加载第二个窗口的数据
        this.getDelegationsByUserId()
        // 加载第三个窗口的数据
        this.searchSession()
      }
    },
    async checkBeforeDelegate() {
      if (this.cachedViews.length) {
        await this.$confirm(StrUtils.substitute(this.$t('Tool.ShutModule'), this.cachedViews.length), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(async() => {
          await this.$store.dispatch('tagsView/delAllViews')
        })
      }
    },
    async goAdminDelegate() {
      await Assert.isTrue(!this.vb1.isAdmin, this.$t('Tool.YouDoNotHaveAccessToTheAdministratorAccount'))
      await this.checkBeforeDelegate()
      await Assert.isTrue(this.vb1.delegator, this.$t('Tool.SelectAccout'))
      await Assert.isTrue(this.vb1.delegator !== this.userId, this.$t('Tool.LoginMySelf'))

      this.goDelegate(this.vb1.delegator)
    },
    async goGridUserDelegate(uid) {
      await this.checkBeforeDelegate()
      this.goDelegate(uid)
    },
    async logoutDelegateAccount() {
      await this.checkBeforeDelegate()
      const localDelegationInfo = LocalStorageUtils.getDelegationInfo()
      logoutDelegate(localDelegationInfo.delegationUuid).then(res => {
        let credential = { delegation: { delegate: false, sessionId: localDelegationInfo.delegateeSessionId }}
        credential = Base64.encode(JSON.stringify(credential))
        const currentDomain = window.location.origin
        window.location.replace(`${currentDomain}/#/?credential=${credential}`)
        window.location.reload()
      })
    },
    goDelegate(delegatorId) {
      delegate(delegatorId).then(res => {
        // 存储原sessionId和 授权的sessionId 根据授权的sessionId重新访问登录
        const { sessionId, delegationUuid } = res.data
        if (res.data && delegationUuid && sessionId) {
          let credential = { delegation: { delegate: true, delegateeSessionId: this.userInfo.sessionId, delegationUuid, sessionId, delegatorId }}
          credential = Base64.encode(JSON.stringify(credential))
          this.$emit('update:delegation', true)
          const currentDomain = window.location.origin
          window.location.replace(`${this.keepHttpOrHttps(currentDomain)}/#/?credential=${credential}`)
          window.location.reload()
        } else {
          this.$message.error(this.$t('Tool.AuthFail'))
        }
      }).catch(err => {
        console.log(err)
        this.$message.error(this.$t('Tool.AuthFail'))
      })
    },
    // 保持http或https一致
    keepHttpOrHttps(url) {
      if (location.href.startsWith('https:')) {
        if (url.startsWith('http:')) {
          url = url.replace('http:', 'https:')
        }
      } else if (location.href.startsWith('http:')) {
        if (url.startsWith('https:')) {
          url = url.replace('https:', 'http:')
        }
      }
      return url
    },
    refreshVb1Grid() {
      getDelegationsByDelegateeId().then(res => {
        this.vb1.rowData = res.data || []
      })
    },
    setVb1Delegator(obj) {
      this.vb1.delegator = obj.value
      this.vb1.isAdmin = [1, 2].includes(obj.type)
    },
    // 授权
    onAddVb2() {
      if (!this.vb2.delegator) {
        this.$message.warning(this.$t('Tool.InputUser'))
        return
      }
      if (this.vb2.delegator === this.$store.getters.userId) {
        this.$message.warning(this.$t('Tool.AuthMyself'))
        return
      }
      if (!this.vb2.startTime) {
        this.$message.warning(this.$t('Tool.BeginDate') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!this.vb2.endTime) {
        this.$message.warning(this.$t('Tool.EndDate') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      const startTime = DateUtils.formatStandardDateTime(this.vb2.startTime)
      const endTime = DateUtils.formatStandardDateTime(this.vb2.endTime)
      if (endTime < startTime) {
        this.$message.warning(this.$t('Pricing.CompareValidate'))
        return
      }
      const user = getObjectByCache(basicCacheKeys.basic_data_User, 'userId', Number(this.vb2.delegator))
      if (user) {
        this.remarkView.remark = ''
        this.remarkView.visible = true
      } else {
        this.$message.warning(this.$t('Tool.InvalidUser'))
      }
    },
    // 确定授权
    handleSubmit() {
      if (!this.remarkView.remark || !this.remarkView.remark.trim()) {
        this.$message.warning(this.$t('Tool.InputAuthReason'))
        return
      }
      const loading = getLoading4Cxt(this)
      const d = {}
      d.delegator = this.$store.getters.userId
      d.delegatee = this.vb2.delegator
      d.startTime = this.vb2.startTime
      d.endTime = this.vb2.endTime
      d.remarks = this.remarkView.remark
      // 保存
      saveDelegate(d).then(res => {
        if (res.data > 0) {
          this.init()
        }
      }).finally(() => {
        loading.close()
        this.handleClose()
      })
    },
    // 取消授权
    handleClose() {
      this.remarkView.visible = false
    },
    // 刷新第二个窗口的数据 根据用户查询自己的授权
    getDelegationsByUserId() {
      const param = {}
      param.anyInteger = this.$store.getters.userId
      getDelegationsByUserId(param).then(res => {
        this.vb2.rowData = res.data || []
      })
    },
    // 第二个窗口选中行，第三个窗口需要数据过滤
    onShowDelegation(event) {
      const curDelegation = event.data
      if (curDelegation) {
        this.searchSession(curDelegation.id)
      }
    },
    // 撤销授权
    onCancelDelegation(uuid = '') {
      stopBubble(uuid)
      if (!uuid) return
      const loading = getLoading4Cxt(this)
      cancelDelegation({ anyStr: uuid }).then(res => {
        if (res.data > 0) {
          this.init()
        }
      }).finally(() => {
        loading.close()
      })
    },
    // 过滤授权使用历史中三个列的数据
    updateDelegationLog() {
      const filterStr = this.vb3.filterStr
      if (!filterStr) {
        this.vb3.rowData = this.vb3.oldData
        return
      }
      this.vb3.rowData = this.vb3.oldData
      const curData = []
      for (const item of this.vb3.rowData) {
        if (item.userId) {
          const user = getObjectByCache(basicCacheKeys.basic_data_User, 'userId', Number(item.userId))
          if (user) {
            const name = this.isZh ? user.chineseName : user.englishName
            if (name && name.indexOf(filterStr) > -1) {
              curData.push(item)
              continue
            }
          }
        }
        if (item.loginDate) {
          const curLoginDate = ColumnUtils.dateTimeLabelFunc(item.loginDate)
          if (curLoginDate && curLoginDate.indexOf(filterStr) > -1) {
            curData.push(item)
            continue
          }
        }
        if (item.logoutDate) {
          const curLogoutDate = ColumnUtils.dateTimeLabelFunc(item.logoutDate)
          if (curLogoutDate && curLogoutDate.indexOf(filterStr) > -1) {
            curData.push(item)
            continue
          }
        }
      }
      this.vb3.rowData = curData
    },
    // 刷新第三个窗口的数据
    onShowAllLog() {
      if (this.vb2.gridApi) {
        this.vb2.gridApi.clearFocusedCell() // 清除选中行
      }
      this.searchSession()
    },
    // 刷新第三个窗口的数据
    searchSession(delegationId = '') {
      const param = {}
      param.anyInteger = this.$store.getters.userId
      if (delegationId) {
        param.anyInteger1 = delegationId
      }
      const loading = getLoading4Cxt(this)
      searchSession(param).then(res => {
        this.vb3.oldData = res.data || []
        this.vb3.rowData = res.data || []
      }).finally(() => {
        loading.close()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.authorization{
  .box-card{
    border: none;
    /deep/ .el-card__body{
      padding: 0;
      .logout-wrap{
        text-align: center;
        margin-right: 70px;
        padding: 60px 0;
      }
      .admin-wrap{
        width: 100%;
        .admin-wrap-form{
          margin: 10px 0 20px 0;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          >label{
            margin-right: 5px;
            font-size: 13px;
          }
          .cargo-advance-select-wrapper{
            width: 200px;
          }
          .go-btn{
            width: 28px;
            height: 28px;
            line-height: 28px;
            margin: 0 10px;
            background-color: #67C23A;
            border-radius: 5px;
            font-family: 'AlibabaPuHuiTiB';
            font-style: normal;
            color: #FFF;
            text-align: center;
            font-size: 12px;
            display: inline-block;
            cursor: pointer;
          }
          .flush-btn{
            min-width: 60px;
            width: 60px;
            background-color: #409EFF;
            border-color: #409EFF;
          }
        }
        .cargo-ag-grid{
          height: 350px;
        }
      }
      .cargo-ag-grid{
        width: 100%;
        .go-link{
          width: 24px;
          height: 24px;
          line-height: 24px;
          border-radius: 3px;
          background-color: #67C23A;
          font-family: 'AlibabaPuHuiTiB';
          font-style: normal;
          color: #FFF;
          text-align: center;
          font-size: 10px;
          display: inline-block;
          cursor: pointer;
          font-weight: normal;
        }
        .x-link{
          width: 24px;
          height: 24px;
          line-height: 24px;
          border-radius: 3px;
          background-color: red;
          font-family: 'AlibabaPuHuiTiB';
          font-style: normal;
          color: #FFF;
          text-align: center;
          font-size: 10px;
          display: inline-block;
          cursor: pointer;
          font-weight: normal;
        }
      }
    }
  }
}

</style>
